class Account {
  constructor(
    { 
      id,
      name,
      email,
      password = null,
      accountGroupID,
      clientID,
      technicianID,
      changePassword,
      visibleVehicle,
      visibleEquipment,
      active,
      reciveEmail,
    }
  ) {
    this.id = id
    this.name = name
    this.email = email
    this.password = password
    this.accountGroupID = accountGroupID
    this.clientID = clientID
    this.technicianID = technicianID
    this.changePassword = changePassword
    this.visibleVehicle = visibleVehicle
    this.visibleEquipment = visibleEquipment
    this.active = active
    this.reciveEmail = reciveEmail
  }
}

export const accountDefault = () => {
  const account = {
    id: 0,
    name: "",
    password: "",
    email: "",
    accountGroupID: 0,
    clientID: null,
    technicianID: null,
    changePassword: true,
    visibleVehicle: null,
    visibleEquipment: null,
    active: true,
    reciveEmail: true
  }
  return account
}

export default Account